import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core';
import Scrollbars from 'react-custom-scrollbars';

import theme from 'sources/muiTheme';
import Routes from 'routes';
import { AuthContextProvider } from 'contexts/AuthContext';
import styles from './App.scss';
import SiteNavBar from './SiteNavBar/SiteNavBar';
import SiteFooter from './SiteFooter/SiteFooter';

function App() {
  return (
    <AuthContextProvider>
      <Router>
        <MuiThemeProvider theme={theme}>
          <Scrollbars
            id="RootScrollbar"
            universal
            autoHeight
            autoHeightMin="80vh"
            autoHeightMax="100vh"
            autoHide
            autoHideTimeout={1000}
            autoHideDuration={300}
          >
            <SiteNavBar />
            <main
              className={styles.main}
              style={{ minHeight: window.innerHeight - 70 }}
            >
              <Routes />
            </main>
            <SiteFooter />
          </Scrollbars>
        </MuiThemeProvider>
      </Router>
    </AuthContextProvider>
  );
}

App.propTypes = {};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.jsx